<div class="flex flex-col gap-4 pb-5 my-2">
  <div class="flex gap-4 items-center">
    <p-button
      type="button"
      [label]="'common.text_groups.add_entity' | translate: { entity: singular | translate }"
      icon="pi pi-plus"
      (onClick)="add()"
      [disabled]="disabled">
    </p-button>

    <p-button
      type="button"
      [label]="'common.text_groups.remove_all' | translate"
      icon="pi pi-trash"
      severity="secondary"
      (onClick)="clearAll()"
      [disabled]="disabled || (rows$ | async)?.length === 0">
    </p-button>
  </div>

  <p-table [value]="(rows$ | async) || []" [tableStyle]="{ 'min-width': '50rem' }" editMode="cell" [rowHover]="true" [trackBy]="trackByRow">
    <ng-template pTemplate="header">
      <tr>
        <th>#</th>
        <th *ngFor="let kv of sortedStructure">{{ kv.value.label || kv.key }}</th>
        <th>{{ 'table.actions.label' | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-i="rowIndex">
      <tr>
        <td>{{ i + 1 }}</td>

        <td *ngFor="let kv of sortedStructure" pEditableColumn>
          <p-cellEditor>
            <!-- Input mode -->
            <ng-template #input>
              <ng-container [ngSwitch]="kv.value.type">
                <input
                  *ngSwitchCase="'string'"
                  pInputText
                  class="w-full"
                  [disabled]="disabled || kv.value.editable === false"
                  [ngModel]="row[kv.key]"
                  (blur)="onInputBlur($event, row, kv.key)"
                  (keydown.enter)="onInputEnter($event, row, kv.key)" />

                <input
                  *ngSwitchCase="'number'"
                  pInputText
                  type="number"
                  [disabled]="disabled || kv.value.editable === false"
                  [ngModel]="row[kv.key]"
                  (blur)="onInputBlur($event, row, kv.key)"
                  (keydown.enter)="onInputEnter($event, row, kv.key)" />

                <p-checkbox
                  *ngSwitchCase="'boolean'"
                  [binary]="true"
                  [disabled]="disabled || kv.value.editable === false"
                  [(ngModel)]="row[kv.key]"
                  (onChange)="update(row, kv.key, $event.checked)">
                </p-checkbox>
              </ng-container>
            </ng-template>

            <!-- Output mode -->
            <ng-template #output>
              <span *ngIf="!row[kv.key]" class="opacity-70 italic cursor-text"> Cliquez pour saisir une valeur </span>
              <span *ngIf="row[kv.key]">{{ row[kv.key] }}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td class="text-center">
          <button type="button" (click)="remove(i)" [disabled]="disabled">
            <i class="pi pi-eraser"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="100%" class="text-center opacity-70 italic">Aucun {{ singular | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
